import * as THREE from "three";

export const ToneMappingDefineKeys = [
  "DM_LINEAR_TONE_MAPPING",
  "DM_REINHARD_TONE_MAPPING",
  "DM_CINEON_TONE_MAPPING",
  "DM_ACES_FILMIC_TONE_MAPPING",
] as const;

type ToneMappingDefineKey = (typeof ToneMappingDefineKeys)[number];
export type ToneMappingDefines = Record<ToneMappingDefineKey, number>;

/**
 * @returns true if defines changed.
 */
export function setToneMappingDefine(defines: ToneMappingDefines, toneMapping: THREE.ToneMapping): boolean {
  let changed = false;
  const linear = toneMapping === THREE.LinearToneMapping ? 1 : 0;
  if (defines.DM_LINEAR_TONE_MAPPING !== linear) {
    defines.DM_LINEAR_TONE_MAPPING = linear;
    changed = true;
  }
  const reinhard = toneMapping === THREE.ReinhardToneMapping ? 1 : 0;
  if (defines.DM_REINHARD_TONE_MAPPING !== reinhard) {
    defines.DM_REINHARD_TONE_MAPPING = reinhard;
    changed = true;
  }
  const cineon = toneMapping === THREE.CineonToneMapping ? 1 : 0;
  if (defines.DM_CINEON_TONE_MAPPING !== cineon) {
    defines.DM_CINEON_TONE_MAPPING = cineon;
    changed = true;
  }
  const acesFilmic = toneMapping === THREE.ACESFilmicToneMapping ? 1 : 0;
  if (defines.DM_ACES_FILMIC_TONE_MAPPING !== acesFilmic) {
    defines.DM_ACES_FILMIC_TONE_MAPPING = acesFilmic;
    changed = true;
  }
  return changed;
}
